/*
 * Copyright © 2023 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { FC_ACCORDION, FcAccordionComponent } from '../fc-accordion.component';

/**
 * Fc accordion item component.
 */
@Component({
    selector: 'fc-accordion-item',
    templateUrl: './fc-accordion-item.component.html',
    styleUrls: ['./fc-accordion-item.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcAccordionItemComponent implements OnInit {
    
    /**
     * Accordion Item header name.
     */
    @Input() name: string = '';

    /**
     * Accordion Item unique id.
     */
    @Input() id: string = '';

    /**
     * Whether the accordion item is disabled.
     */
    @Input() disabled: boolean = false;

    /**
     * Whether the accordion item is expanded.
     */
    @Input() expanded: boolean = false;

    /**
     * Event emitted whenever the accordion item is toggle.
     */
    @Output() readonly toggle: EventEmitter<any> = new EventEmitter<any>();

    /**
     * Constructor.
     * 
     * @param accordion FcAccordionComponent.
     */
    constructor(@Inject(FC_ACCORDION) public accordion: FcAccordionComponent) {}

    /**
     * OnInit hook.
     * 
     * @throws Error.
     */
    ngOnInit(): void {
        if (!this.id) {
            throw new Error('The "id" input is required for accordion item!');
        }
    }

    /**
     * Toggle the expanded state of the accordion item.
     * 
     * @param id Item id.
     */
    toggleItem(id: string): void {
        if (!this.disabled) {
            this.expanded = !this.expanded;
            this.expansionDispatcher(id);
            this.toggle.emit({id, name: this.name, expanded: this.expanded});
        }
    }

    /**
     * Expansion Dispatcher.
     * 
     * @param id Item id.
     */
    expansionDispatcher(id: string) {
        if (this.accordion && !this.accordion.multi) {
            this.accordion.accordionItems.forEach((accordionItem: FcAccordionItemComponent) => {
                if (accordionItem.id !== id) {
                    accordionItem.expanded = false;
                }
            });
        }
    }
}

